var map = {
	"./di1.png": 3056,
	"./di2.png": 8459,
	"./di3.png": 1154,
	"./di4.png": 3949,
	"./di5.png": 2820,
	"./di6.png": 5279,
	"./di7.png": 182,
	"./di8.png": 6337,
	"./di9.png": 3624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 704;